import { useEffect } from 'react';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ContactModal({ isOpen, onClose }: ContactModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleKakaoClick = () => {
    window.open('http://pf.kakao.com/_rgxdWn/chat', '_blank');
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div 
        className="relative bg-white rounded-xl mx-4 w-full max-w-[320px] shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <h3 className="text-center text-lg font-bold text-gray-900 mb-6">
            문의하기
          </h3>
          
          {/* 카카오톡 문의 섹션 */}
          <div className="mb-6">
            <button
              onClick={handleKakaoClick}
              className="w-full py-4 px-4 bg-[#FEE500] text-black rounded-lg text-base font-medium hover:bg-[#F7DC00] transition-colors"
            >
              카카오톡 문의하기
            </button>
            <p className="text-center text-xs text-gray-500 mt-2">
              PC 카카오톡이 있으면 데스크톱에서도 이용 가능합니다
            </p>
          </div>
          
          {/* 구분선 */}
          <div className="border-t border-gray-200 my-6"></div>
          
          {/* 이메일 문의 섹션 */}
          <div className="text-center">
            <p className="text-sm font-medium text-gray-900 mb-2">
              이메일로 문의하기
            </p>
            <p className="text-base text-blue-600 font-medium select-text cursor-text">
              ecodeal_cs@ecodeal.kr
            </p>
            <p className="text-xs text-gray-500 mt-2">
              위 이메일로 문의 내용을 보내주세요
            </p>
          </div>
          
          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            className="w-full mt-6 py-3 px-4 bg-gray-100 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-200 transition-colors"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}